export const dynamic = 'force-dynamic'
import React from 'react'

import { Metadata } from 'next';

import ServicesPage from '@/components/Services/ServicesPage';
export const metadata: Metadata = {
  title: 'Services | TEX EXCELLENCE LIMITED',
  description: 'Services | TEX EXCELLENCE LIMITED',
}

export default function ServicesPageRoute() {
  
  return (

    <ServicesPage />

  )
}

// export default ProductPageRoute
